<nav class="navbar" role="navigation" aria-label="main navigation">
  <ng-container>
      <ul role="menu" class="menu">
        <ng-content></ng-content>
      </ul>
  </ng-container>
</nav>
